import { useState } from "react";
import { Outlet, Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "@/components/Logo";

const NAV = [
  { to: "/about", label: "About" },
  { to: "/how-it-works", label: "How It Works" },
  { to: "/for-workers", label: "For Workers" },
  { to: "/for-businesses", label: "For Businesses" },
  { to: "/global-workforce", label: "Global Workforce" },
  { to: "/opportunities", label: "Opportunities" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
];

export default function PublicLayout() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-white text-[#0F172A] flex flex-col">
      <header className="sticky top-0 z-50 bg-white/90 backdrop-blur border-b border-slate-100">
        <div className="max-w-7xl mx-auto px-5 h-16 flex items-center justify-between">
          <Logo />
          <nav className="hidden lg:flex items-center gap-6">
            {NAV.map((n) => (
              <NavLink key={n.to} to={n.to} data-testid={`nav-${n.label.toLowerCase().replace(/ /g, "-")}`}
                className={({ isActive }) => `text-sm font-medium transition-colors hover:text-[#1D4ED8] ${isActive ? "text-[#1D4ED8]" : "text-slate-600"}`}>
                {n.label}
              </NavLink>
            ))}
          </nav>
          <div className="hidden lg:flex items-center gap-3">
            <button onClick={() => navigate("/login")} data-testid="nav-login-btn" className="text-sm font-semibold text-slate-700 hover:text-[#0A1128]">Login</button>
            <button onClick={() => navigate("/register")} data-testid="nav-register-btn" className="text-sm font-semibold px-4 py-2 rounded-full bg-[#1D4ED8] text-white hover:bg-[#1E40AF] transition-colors">Get Started</button>
          </div>
          <button className="lg:hidden" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
            {open ? <X /> : <Menu />}
          </button>
        </div>
        {open && (
          <div className="lg:hidden border-t border-slate-100 px-5 py-4 space-y-2 bg-white">
            {NAV.map((n) => (
              <Link key={n.to} to={n.to} onClick={() => setOpen(false)} className="block py-2 text-slate-700 font-medium">{n.label}</Link>
            ))}
            <div className="flex gap-3 pt-2">
              <Link to="/login" className="flex-1 text-center py-2 rounded-full border border-slate-200 font-semibold">Login</Link>
              <Link to="/register" className="flex-1 text-center py-2 rounded-full bg-[#1D4ED8] text-white font-semibold">Get Started</Link>
            </div>
          </div>
        )}
      </header>
      <main className="flex-1"><Outlet /></main>
      <footer className="bg-[#0A1128] text-slate-300 mt-20">
        <div className="max-w-7xl mx-auto px-5 py-14 grid md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <Logo dark />
            <p className="mt-4 text-sm text-slate-400 max-w-sm">One Global Workforce. One Operating System. GTForce powers distributed field, sales and task operations across cities, countries and time zones.</p>
          </div>
          <div>
            <h4 className="font-head font-semibold text-white mb-3">Platform</h4>
            <ul className="space-y-2 text-sm text-slate-400">
              {NAV.slice(0, 5).map((n) => <li key={n.to}><Link to={n.to} className="hover:text-[#1D4ED8]">{n.label}</Link></li>)}
            </ul>
          </div>
          <div>
            <h4 className="font-head font-semibold text-white mb-3">Get started</h4>
            <ul className="space-y-2 text-sm text-slate-400">
              <li><Link to="/register" className="hover:text-[#1D4ED8]">Join as Worker</Link></li>
              <li><Link to="/contact" className="hover:text-[#1D4ED8]">Talk to Sales</Link></li>
              <li><Link to="/login" className="hover:text-[#1D4ED8]">Sign in</Link></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-white/10 py-5 text-center text-xs text-slate-500">© {new Date().getFullYear()} GTForce — Global Task Force. All rights reserved.</div>
      </footer>
    </div>
  );
}
